export default __webpack_public_path__ + "static/media/chemistryIcon.747d79e9.svg";